module.exports = __webpack_public_path__ + "img/menu-pays.420c65b1.svg";